export enum TeamInvitationStatus {
  PENDING = "pending",
  EXPIRED = "expired",
  ACCEPTED = "accepted",
  DECLINED = "declined"
}
